import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  const accentColor = props.color || theme.colors.primary

  return {
    button: {
      padding: '8px 20px',
      '&:not(:last-child)': {
        marginRight: '30px',
      },
    },
    filledButton: {
      backgroundColor: accentColor,
      color: theme.colors.white,
      filter: 'brightness(1)',
      transition: 'filter .3s',
      '&:hover': {
        backgroundColor: accentColor,
        filter: 'brightness(1.3)',
      },
    },
    popupTextBlock: {
      marginTop: '16px',
    },
    subheader: {
      fontFamily: 'sans-serif',
      fontWeight: 'bold',
    },
    popupTip: {
      marginTop: '24px',
      color: '#ccc',
      fontStyle: 'italic',
    },
    dropzone: {
      color: '#000',
      marginTop: 24,
      minWidth: 100,
      cursor: 'pointer',
      '& > div:nth-child(2)': {
        width: '100%',
      },
    },
    dropArea: {
      '& > div:nth-child(2)': {
        position: 'relative',
        width: '100%',
      },
    },
    validationError: {
      color: theme.colors.red,
      marginTop: '6px',
    },
    downloadButton: {
      color: accentColor,
      textDecoration: 'underline',
    },
  }
}
